import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ForgeButtonModule, ForgeIconButtonModule, ForgeIconModule } from '@tylertech/forge-angular';
import { IconRegistry } from '@tylertech/forge';
import { tylIconKeyboardArrowRight } from '@tylertech/tyler-icons/standard';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { Arrest, ImageDetails, Inmate, InmatesService } from "@tylertech/cj-inmate-search-angular-sdk";
import { DatePipe } from '@angular/common';
import { InstanceConfigService } from 'src/app/core/services/instance-config.service';
import { toMugshotDetails } from 'src/app/utils/image.utils';

@Component({
  selector: 'inmate-card',
  standalone: true,
  imports: [ForgeIconButtonModule, ForgeIconModule, ForgeButtonModule, SharedModule, DatePipe],
  templateUrl: './inmate-card.component.html',
  styleUrls: ['./inmate-card.component.scss']
})
export class InmateCardComponent implements OnChanges {
  @Input() inmate!: Inmate;

  protected mugshotImageDetails: ImageDetails | null = null;

  constructor(
    private readonly _inmateService: InmatesService,
    private readonly _instanceConfigService: InstanceConfigService
  ) {
    IconRegistry.define([tylIconKeyboardArrowRight]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hideMugshots = this._instanceConfigService.inmateVisibilitySnapshot?.hideMugShots ?? false;

    if (!hideMugshots && changes.inmate) this.loadMugshot();
  }

  private loadMugshot() {
    const isDoc = (this.inmate as any)?.recordType === 'DOC';
    if (!this.inmate?.imageServiceClientId && !isDoc) {
      this.mugshotImageDetails = null;
      return;
    }
    this._inmateService.getInmateImage(this.inmate.instanceId, this.inmate.id, this.inmate.imageServiceClientId).subscribe({
      next: (imageDetails) => {
        this.mugshotImageDetails = toMugshotDetails(imageDetails);
      },
      error: (err) => {
        this.mugshotImageDetails = null;
        if (err.status === 404) return;
        console.error(err);
      }
    });
  }

  protected onImageError(): void {
    this.mugshotImageDetails = null;
  }

  getMostRecentArrestDate(): Date | null {
    // Find the most recent arrest date
    const mostRecentArrest = this.getMostRecentArrest();
    return mostRecentArrest?.arrestDate ? new Date(mostRecentArrest.arrestDate) : null;
  }

  getMostRecentArrestingAgency(): string | null {
    if (!this.inmate.arrests || this.inmate.arrests.length === 0) {
      return null;
    }

    // Get the arresting agency from the most recent arrest
    const mostRecentArrest = this.getMostRecentArrest();
    return mostRecentArrest?.arrestingAgency ?? null;
  }

  private getMostRecentArrest(): Arrest | null {
    if (!this.inmate.arrests || this.inmate.arrests.length === 0) {
      return null;
    }
    return this.inmate.arrests
      .filter(arrest => arrest.arrestDate)
      .sort((a, b) => {
        const dateA = new Date(a.arrestDate as string).getTime();
        const dateB = new Date(b.arrestDate as string).getTime();
        return dateB - dateA; // Sort in descending order (most recent first)
      })[0];
  }

  viewInmateDetails(inmate: Inmate): void {
    // This method can be used to navigate to a different page to view more details about the inmate
  }
}